<!--
 * @Author: ���� 371824572@qq.com
 * @Date: 2024-05-29 10:41:20
 * @LastEditors: ���� 371824572@qq.com
 * @LastEditTime: 2024-06-26 15:32:31
 * @FilePath: \frontend\src\views\RatingAgency\RatingAgency.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div>
        <!-- 评分机构 -->
        <transition name="el-zoom-in-top">
        <!-- <div v-if="show1">
                <el-row>
                <el-col :span="16">
                    <div class="grid-content bg-purple">
                        <el-input prefix-icon="el-icon-search" v-model="input" style="width: 300px;"
                            placeholder="请输入机构名称" @keyup.enter.native="handleQuery"></el-input>

                            <el-button type="primary" @click="handleQuery" style="margin-left: 20px;">查询</el-button>
                            <el-select v-model="checkValue" placeholder="请选择" @change="checkDataChoose" style="margin-left: 20px;" >
                                <el-option
                                v-for="item in checkData"
                                :key="item.Id"
                                :label="item.Name"
                                :value="item.Id">
                                </el-option>
                            </el-select>
                    </div>
                </el-col>
            </el-row>
            <div style="margin-top: 20px;">
                <el-table :data="tableData" border style="width: 100%">
                    <el-table-column prop="Id" label="标准序号" width="100" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="Name" label="医疗机构名称" width="300" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="State" width="100" label="评级状态" align="center" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.State === 1" effect="dark" type="info">未提交</el-tag>
                            <el-tag v-if="scope.row.State === 2" effect="dark" type="success">已提交</el-tag>
                            <el-tag v-if="scope.row.State === 3" effect="dark" >未通过</el-tag>
                            <el-tag v-if="scope.row.State === 4" effect="dark" type="warning">已通过</el-tag>
                            <el-tag v-if="scope.row.State === 5" effect="dark" type="danger">已考核</el-tag>
                            <el-tag v-if="scope.row.State === 6" effect="dark" type="success">已归档</el-tag>
                        </template>
                        </el-table-column>
                    <el-table-column prop="Score" label="得分" width="90" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column prop="ScoreDate" label="评级时间" width="200" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column fixed="right" label="操作">
                        <template slot-scope="scope">
                            <el-button @click="handleClickDetail(scope.row)" v-if="scope.row.State != 1&&scope.row.State != null" type="text" size="small">查看详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                        <!--工具条-->
                <!-- <el-col :span="24" class="toolbar">
                    <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange" :page-size="pageSize"
                        :total="total" style="float: right"></el-pagination>
                </el-col>
            </div>
        </div> --> -->
        </transition>
        <!-- 迎评机构 -->
        <transition name="el-zoom-in-center">
            <div v-if="show2">
                <EvaluationAgency :ratingData="ratingData" :checkDatas="checkData" :checkpValue="checkpValue" @onEmitIndex="onEmitIndex"></EvaluationAgency>
            </div>
        </transition>
        
    </div>
</template>

<script>

import {
    getSelectRatingAgencyList
} from "../../api/EvaluationAgency/EvaluationAgency";
import EvaluationAgency from "../EvaluationAgency/EvaluationAgency.vue";
import {
    GetCheck
} from "../../api/RatingManage/RatingManage";
export default {
    components: { EvaluationAgency },
    data() {
        return {
            pageSize:20,
            pageIndex:1,
            total:0,
            ratingData:"",//机构id
            show2: false,
            show1:true,
            input:"",
            tableData:[],
            checkData:[],
            checkValue:"",
            checkpValue:""
        }
    },
    created(){
        this.GetCheckData();
    },
    mounted(){
    },
    methods:{
        //获取考核表
        async GetCheckData()
        {
            let para = {
                page: 1,
                key: "",
                pageSize: 1000,
            };
            await GetCheck(para).then((res)=>{
                console.log(res.data);
                if (res.data.success) {
                    this.checkData=res.data.response.data;
                    if (sessionStorage.getItem('checkId')!=null) {
                        this.checkValue=sessionStorage.getItem('checkId');
                    }else{
                        if (this.checkData.length>0) {
                            this.checkValue=this.checkData[0].Id;
                        }
                    }
                    //机构ID
                    this.ratingData=this.$store.state.hospitalId;
                    this.show2=true;
                    this.checkpValue= this.checkValue
                    this.show1=false;
                    // this.handleQuery();
                }
            });
        },
        checkDataChoose(id)
        {
            sessionStorage.setItem('checkId', id);
            this.handleQuery();
        },
        handleQuery()
        {
            this.loadTableList();
        },
        handleClickDetail(row)
        { 
            //机构ID
            this.ratingData=row.Id;
            this.show2=true;
            this.checkpValue=this.checkValue
            this.show1=false;
        },
        onEmitIndex(idx)
        {
            this.show2=false;
            this.show1=true;
        },
        handleCurrentChange(val) {
            this.pageIndex = val;
            this.loadTableList();
        },
        loadTableList()
        {
            let parms={
                chenckId:this.checkValue,
                key:this.input,
                page:this.pageIndex,
                intPageSize:this.pageSize
            };
            getSelectRatingAgencyList(parms).then((res)=>{
                if(res.success)
                {
                    this.tableData=res.response.data;
                    this.total = res.response.dataCount;
                    this.pageIndex=res.response.page;
                    this.pageSize=res.response.PageSize;
                }
            })    
        }
    }
}
</script>

<style lang="less" scoped>

</style>